/**
 * Replace translation dynamic values string.
 * This function returns value replaced string.
 * @returns {String}
 */
var setTranslationValues = function (translation, values) {
    if (translation === void 0) { translation = ''; }
    if (values === void 0) { values = {}; }
    for (var key in values) {
        translation = translation.replaceAll("{{".concat(key, "}}"), "".concat(values[key]));
    }
    return translation;
};

export { setTranslationValues };
